import { createFileRoute } from "@tanstack/react-router";
import { Require } from "../features/require";
import { OrderingSettingsPage } from "../features/settings/ordering-settings-page";

export const Route = createFileRoute("/more/ordering")({ component: Page });

function Page() {
	return (
		<Require permission="settings.manage">
			<OrderingSettingsPage />
		</Require>
	);
}
